var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.69L22.5 8.31C22.5 4.67 20.33 2.5 16.69 2.5L8.32 2.5C4.67 2.5 2.5 4.67 2.5 8.31L2.5 16.68C2.5 20.32 4.67 22.49 8.31 22.49L16.69 22.49C20.33 22.5 22.5 20.33 22.5 16.69ZM11.19 7.5C11.19 6.78 11.78 6.19 12.5 6.19C13.22 6.19 13.81 6.78 13.81 7.5C13.81 8.22 13.22 8.81 12.5 8.81C11.78 8.81 11.19 8.22 11.19 7.5ZM11.19 12.5C11.19 11.78 11.78 11.19 12.5 11.19C13.22 11.19 13.81 11.78 13.81 12.5C13.81 13.22 13.22 13.81 12.5 13.81C11.78 13.81 11.19 13.22 11.19 12.5ZM11.19 17.5C11.19 16.78 11.78 16.19 12.5 16.19C13.22 16.19 13.81 16.78 13.81 17.5C13.81 18.22 13.22 18.81 12.5 18.81C11.78 18.81 11.19 18.22 11.19 17.5Z",
    fill: "#275DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBlue);
export default __webpack_public_path__ + "static/media/details-blue.6f6f085261e05d0600900d53397a8287.svg";
export { ForwardRef as ReactComponent };